<template>
  <div>
    <!-- <sidebar> -->
    <div class="sidebar" id="sidebar">
      <div class="sidebar-inner" id="style-15">
        <vue-custom-scrollbar
          class="scroll-area"
          :settings="settings"
          @ps-scroll-x="scrollHanle"
        >
          <div id="sidebar-menu" class="sidebar-menu">
            <ul v-if="isOwner == true">
              <li class="menu-title">
                <span>Dashboard</span>
              </li>
              <li
                :class="{
                  active: currentpage === '/index' || currentpage === '/'
                }"
              >
                <router-link to="/index" class="clients">
                  <i class="fa fa-television" aria-hidden="true"></i>
                  <span>Monitoring</span>
                </router-link>
              </li>
              <li :class="{ active: currentpage === '/instagram' }">
                <router-link to="/instagram" class="clients">
                  <i class="fa fa-instagram" aria-hidden="true"></i>
                  <span>Instagram</span>
                </router-link>
              </li>
              <li class="menu-title">
                <span>Monitoring</span>
              </li>
              <li
                :class="{ active: currentpage === '/monitoring/scrape/list' }"
              >
                <router-link to="/monitoring/scrape/list" class="clients">
                  <i class="la la-cloud-download"></i>
                  <span>Scrape</span>
                </router-link>
              </li>
              <li :class="{ active: currentpage === '/monitoring/logs/list' }">
                <router-link to="/monitoring/logs/list" class="clients">
                  <i class="la la-folder"></i>
                  <span>Logs</span>
                </router-link>
              </li>
              <li :class="{ active: currentpage === '/monitoring/links/list' }">
                <router-link to="/monitoring/links/list" class="clients">
                  <i class="la la-link"></i>
                  <span>Links</span>
                </router-link>
              </li>
              <li
                :class="{
                  active: currentpage === '/monitoring/bookmarks/list'
                }"
              >
                <router-link to="/monitoring/bookmarks/list" class="clients">
                  <i class="la la-bookmark"></i>
                  <span>Bookmarks</span>
                </router-link>
              </li>
              <li
                :class="{
                  active: currentpage === '/monitoring/trash/list'
                }"
              >
                <router-link to="/monitoring/trash/list" class="clients">
                  <i class="la la-trash"></i>
                  <span>Trash</span>
                </router-link>
              </li>
              <li class="menu-title">
                <span>Statistik</span>
              </li>
              <li :class="{ active: currentpage === '/statistik/harian' }">
                <router-link to="/statistik/harian" class="clients">
                  <i class="la la-clipboard"></i>
                  <span>Harian</span>
                </router-link>
              </li>
              <li :class="{ active: currentpage === '/statistik/brands' }">
                <router-link to="/statistik/brands" class="clients">
                  <i class="la la-clipboard"></i>
                  <span>Brands</span>
                </router-link>
              </li>
              <li :class="{ active: currentpage === '/statistik/products' }">
                <router-link to="/statistik/products" class="clients">
                  <i class="la la-clipboard"></i>
                  <span>Products</span>
                </router-link>
              </li>
              <li class="menu-title">
                <span>Instagram Unofficial API</span>
              </li>
              <li
                :class="{ active: currentpage === '/instagram/accounts/list' }"
              >
                <router-link to="/instagram/accounts/list" class="clients">
                  <i class="la la-user"></i>
                  <span>Accounts</span>
                </router-link>
              </li>
              <li :class="{ active: currentpage === '/instagram/post/list' }">
                <router-link to="/instagram/post/list" class="clients">
                  <i class="la la-image"></i>
                  <span>Post Schedule</span>
                </router-link>
              </li>
              <li :class="{ active: currentpage === '/instagram/logs/list' }">
                <router-link to="/instagram/logs/list" class="clients">
                  <i class="la la-image"></i>
                  <span>Logs</span>
                </router-link>
              </li>
              <li class="menu-title">
                <span>Instagram Official API</span>
              </li>
              <li
                :class="{
                  active: currentpage === '/instagram/accounts/list_official'
                }"
              >
                <router-link
                  to="/instagram/accounts/list_official"
                  class="clients"
                >
                  <i class="fa fa-user"></i>
                  <span>Accounts</span>
                </router-link>
              </li>
              <li
                :class="{
                  active: currentpage === '/instagram-official/post/list'
                }"
              >
                <router-link to="/instagram-official/post/list" class="clients">
                  <i class="la la-image"></i>
                  <span>Post Schedule</span>
                </router-link>
              </li>
              <li
                :class="{
                  active: currentpage === '/instagram-official/logs/list'
                }"
              >
                <router-link to="/instagram-official/logs/list" class="clients">
                  <i class="la la-image"></i>
                  <span>Logs</span>
                </router-link>
              </li>
              <li class="menu-title">
                <span>Client</span>
              </li>
              <li :class="{ active: currentpage === '/client/brands/list' }">
                <router-link to="/client/brands/list" class="clients">
                  <i class="fa fa-tags"></i>
                  <span>Brands</span>
                </router-link>
              </li>
              <li :class="{ active: currentpage === '/client/products/list' }">
                <router-link to="/client/products/list" class="clients">
                  <i class="la la-tree"></i>
                  <span>Products</span>
                </router-link>
              </li>
              <li :class="{ active: currentpage === '/client/seller/list' }">
                <router-link to="/client/seller/list" class="clients">
                  <i class="la la-exclamation-circle"></i>
                  <span>Exclude Seller</span>
                </router-link>
              </li>
              <li :class="{ active: currentpage === '/client/agents/list' }">
                <router-link to="/client/agents/list" class="agents">
                  <i class="la la-user"></i>
                  <span>Agents</span>
                </router-link>
              </li>
              <!-- <li :class="{'active': currentpage === '/client/instagram_accounts/list'}">
                <router-link to="/client/instagram_accounts/list" class="clients">
                  <i class="la la-instagram"></i>
                  <span>Instagram Accounts</span>
                </router-link>
              </li>-->
              <!--               
              <li class="menu-title">
                <span>Toolkit</span>
              </li>
              <li :class="{'active': currentpage === '/toolkit/working-hours/list'}">
                <router-link to="/toolkit/working-hours/list" class="clients">
                  <i class="fa fa-clock-o"></i>
                  <span>Working Hours</span>
                </router-link>
              </li>
              <li :class="{'active': currentpage === '/toolkit/operator/list'}">
                <router-link to="/toolkit/operator/list" class="clients">
                  <i class="fa fa-support"></i>
                  <span>Operator</span>
                </router-link>
              </li>
              <li :class="{'active': currentpage === '/toolkit/link_generator/list'}">
                <router-link to="/toolkit/link_generator/list" class="clients">
                  <i class="fa fa-link"></i>
                  <span>Link Generator</span>
                </router-link>
              </li>-->
              <!-- <li class="menu-title">
                <span>Pages</span>
              </li>
              <li :class="{'active': currentpage === '/faq'}">
                <router-link to="/faq" class="faq">FAQ</router-link>
              </li>
              <li>
                <a href="https://help.waajo.id" target="_blank">Help Desk</a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://www.youtube.com/channel/UCvW5ivbvIoBCyC4tXhHbh5A"
                  class="terms"
                >Video Tutorial</a>
              </li>-->
              <!--  <li>
                <router-link to="/privacypolicy" class="privacypolicy">Privacy Policy</router-link>
              </li>-->
            </ul>
            <ul v-else>
              <li class="menu-title">
                <span>Dashboard</span>
              </li>
              <li
                :class="{
                  active: currentpage === '/index-agent'
                }"
              >
                <router-link to="/index-agent" class="clients">
                  <i class="fa fa-television" aria-hidden="true"></i>
                  <span>Monitoring</span>
                </router-link>
              </li>
              <li class="menu-title">
                <span>Monitoring</span>
              </li> 
              <li :class="{ active: currentpage === '/monitoring-agent/links/list' }">
                <router-link to="/monitoring-agent/links/list" class="clients">
                  <i class="la la-link"></i>
                  <span>Links</span>
                </router-link>
              </li> 
              <li class="menu-title">
                <span>Statistik</span>
              </li>
              <li
                :class="{ active: currentpage === '/statistik-agent/harian' }"
              >
                <router-link to="/statistik-agent/harian" class="clients">
                  <i class="la la-clipboard"></i>
                  <span>Harian</span>
                </router-link>
              </li>
              <li
                :class="{ active: currentpage === '/statistik-agent/brands' }"
              >
                <router-link to="/statistik-agent/brands" class="clients">
                  <i class="la la-clipboard"></i>
                  <span>Brands</span>
                </router-link>
              </li>
              <li
                :class="{ active: currentpage === '/statistik-agent/products' }"
              >
                <router-link to="/statistik-agent/products" class="clients">
                  <i class="la la-clipboard"></i>
                  <span>Products</span>
                </router-link>
              </li>
            </ul>
          </div>
        </vue-custom-scrollbar>
      </div>
    </div>
    <!-- </sidebar> -->
  </div>
</template>
<script>
import vueCustomScrollbar from "vue-custom-scrollbar";
import "vue-custom-scrollbar/dist/vueScrollbar.css";
import { mapGetters } from "vuex";
import { hasPermissionForRoute } from "@/utils/helper";

export default {
  components: {
    vueCustomScrollbar
  },
  mounted() {
    $("#sidebar-menu a").on("click", function(e) {
      if (
        $(this)
          .parent()
          .hasClass("submenu")
      ) {
        e.preventDefault();
      }
      if (!$(this).hasClass("subdrop")) {
        $("ul", $(this).parents("ul:first")).slideUp(350);
        $("a", $(this).parents("ul:first")).removeClass("subdrop");
        $(this)
          .next("ul")
          .slideDown(350);
        $(this).addClass("subdrop");
      } else if ($(this).hasClass("subdrop")) {
        $(this).removeClass("subdrop");
        $(this)
          .next("ul")
          .slideUp(350);
      }
    });
    $("#sidebar-menu ul li.submenu a.active")
      .parents("li:last")
      .children("a:first")
      .addClass("active")
      .trigger("click");
  },
  computed: {
    isJoinAffiliate() {
      return this.$store.state.referral.isJoin;
    },
    ...mapGetters(["agentSession", "rolesMember"]),
    isOwner() {
      if (typeof this.agentSession.is_owner == "undefined") {
        return true;
      } else {
        if (this.agentSession.is_owner == 1) {
          return true;
        } else {
          return false;
        }
      }
    },
    currentpage() {
      console.log("this.$route", this.$route);
      return this.$route.path;
    }
  },
  data() {
    return {
      settings: {
        suppressScrollX: false
      },
      activeClass: "active"
    };
    //  isactive : true
  },
  methods: {
    hasPermissionForRoute(roles, route) {
      return hasPermissionForRoute(roles, route);
    },
    scrollHanle(evt) {
      console.log(evt);
    }
  }
};
</script>
<style>
.scroll-area {
  position: relative;
  margin: auto;
  height: calc(100vh - 60px);
  background-color: transparent !important;
}
/* .ps__rail-y {
        top: 0px !important;
    height: 657px !important;
    right: -3px !important;
    background-color: transparent !important;
        } */
</style>



// WEBPACK FOOTER //
// src/components/layouts/Sidebar.vue